import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from 'ish-shared/shared.module';

import { CustomProductCategoryLinkComponent } from './custom-product-category-link/custom-product-category-link.component';
import { ProductBundlePartsComponent } from './product-bundle-parts/product-bundle-parts.component';
import { ProductDetailActionsComponent } from './product-detail-actions/product-detail-actions.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductImagesComponent } from './product-images/product-images.component';
import { ProductLinksListComponent } from './product-links-list/product-links-list.component';
import { ProductMasterVariationsComponent } from './product-master-variations/product-master-variations.component';
import { ProductPageComponent } from './product-page.component';
import { RetailSetPartsComponent } from './retail-set-parts/retail-set-parts.component';
import { ProductLinksCarouselComponent } from './product-links-carousel/product-links-carousel.component.all';
import { ProductLinksComponent } from './product-links/product-links.component';

const productPageRoutes: Routes = [
  {
    /* DIAS PWA Customization for product routing */
    path: 'p/:sku',
    component: ProductPageComponent,
  },
  {
    // compatibility to old routes
    path: 'product/:sku',
    component: ProductPageComponent,
  },
  {
    // compatibility to old routes
    path: 'category/:categoryUniqueId/product/:sku',
    component: ProductPageComponent,
  },
  { path: '**', component: ProductPageComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(productPageRoutes),
    CustomProductCategoryLinkComponent,
    ProductBundlePartsComponent,
    ProductDetailActionsComponent,
    ProductDetailComponent,
    ProductImagesComponent,
    ProductLinksCarouselComponent,
    ProductLinksComponent,
    ProductLinksListComponent,
    ProductMasterVariationsComponent,
    ProductPageComponent,
    RetailSetPartsComponent,
    SharedModule,
  ],
  exports: [],
})
export class ProductPageModule {}
